import request from '@/router/axios'

/**
 * 获取美团订单数据记录
 * @param data
 *
 */
export const getOrderList = (data) => {
  return request({
    // url: 'http://192.168.31.207:8715/order/mt/page',
    url: 'https://trip.ayundi.cn/trip-order/order/mt/page',
    method: 'post',
    data
  })
}

/**
 * 获取美团渠道询价记录
 * @param data
 *
 */
export const getChannelList = (data) => {
  return request({
    // url: 'http://192.168.31.250:8899/trip-order/log/mt/estimatePrice',
    url: 'https://trip.ayundi.cn/trip-order/log/mt/estimatePrice',
    method: 'POST',
    data
  })
}

/**
 * 获取线路
 * @param data
 *
 */
export const getLineList = (data) => {
  return request({
    // url: 'http://192.168.31.250:8899/trip-order/common/line/list',
    url: 'https://trip.ayundi.cn/trip-order/common/line/list',
    method: 'POST',
    data
  })
}

/**
 * 获取电子围栏城市列表
 * @param data
 *
 */
export const cityList = () => {
  return request({
    // url: 'http://192.168.31.251:8715/log/mt/cityList',
    url: 'https://trip.ayundi.cn/trip-order/log/mt/cityList',
    method: 'GET'
  })
}

/**
 * 获取城市电子围栏
 * @param data
 *
 */
export const cityFence = (data) => {
  return request({
    // url: 'http://192.168.31.251:8715/log/mt/cityFence',
    url: 'https://trip.ayundi.cn/trip-order/log/mt/cityFence',
    method: 'POST',
    data
  })
}
/**
 * 获取城市所有订单
 * @param data
 *
 */
export const estimatePriceAll = (data) => {
  return request({
    // url: 'http://192.168.31.251:8715/log/mt/cityFence',
    url: 'https://trip.ayundi.cn/trip-order/log/mt/estimatePrice/all',
    method: 'POST',
    data
  })
}
